import { render, staticRenderFns } from "./CsimSchemaAttribute.vue?vue&type=template&id=de2abf80&scoped=true"
import script from "./CsimSchemaAttribute.vue?vue&type=script&lang=js"
export * from "./CsimSchemaAttribute.vue?vue&type=script&lang=js"
import style0 from "./CsimSchemaAttribute.vue?vue&type=style&index=0&id=de2abf80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2abf80",
  null
  
)

export default component.exports